import { useCallback, useRef } from "react";

interface SwipeOptions {
  threshold?: number;
  onDismiss: () => void;
}

interface SwipeHandlers {
  onPointerDown: (e: React.PointerEvent) => void;
  onPointerMove: (e: React.PointerEvent) => void;
  onPointerUp: () => void;
}

export function useSwipeToDismiss({ threshold = 90, onDismiss }: SwipeOptions): SwipeHandlers {
  const startX = useRef(0);
  const currentX = useRef(0);
  const cardRef = useRef<HTMLDivElement>(null);

  const onPointerDown = useCallback((e: React.PointerEvent) => {
    startX.current = e.clientX;
    currentX.current = e.clientX;
    if (cardRef.current) {
      cardRef.current.style.transition = "none";
    }
  }, []);

  const onPointerMove = useCallback((e: React.PointerEvent) => {
    currentX.current = e.clientX;
    const deltaX = currentX.current - startX.current;
    if (cardRef.current && deltaX > 0) {
      const opacity = Math.max(0, 1 - deltaX / 300);
      cardRef.current.style.transform = `translateX(${deltaX}px)`;
      cardRef.current.style.opacity = String(opacity);
    }
  }, []);

  const onPointerUp = useCallback(() => {
    const deltaX = currentX.current - startX.current;
    if (cardRef.current) {
      cardRef.current.style.transition = "transform 200ms ease, opacity 200ms ease";
      if (deltaX >= threshold) {
        cardRef.current.style.transform = "translateX(300px)";
        cardRef.current.style.opacity = "0";
        setTimeout(onDismiss, 200);
      } else {
        cardRef.current.style.transform = "";
        cardRef.current.style.opacity = "";
      }
    }
  }, [threshold, onDismiss]);

  return { onPointerDown, onPointerMove, onPointerUp };
}
